import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mx-2" }
const _hoisted_2 = { class: "mr-4" }
const _hoisted_3 = {
  key: 2,
  class: "mt-2"
}

import { computed } from 'vue';
import { useLayoutStore } from '@/store/layout';
import { useLayoutField } from '@/composables/useLayoutField';
import { useDisplay } from 'vuetify';


const __default__ = {};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Pagination',
  props: {
    moduleName: {}
  },
  setup(__props: any) {

const props = __props;

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

const page = useLayoutField(props.moduleName, 'page');
const itemsPerPage = useLayoutField(props.moduleName, 'itemsPerPage');
const totalItems = useLayoutField(props.moduleName, 'totalItems');

const totalPages = computed(() =>
  Math.ceil(totalItems.value / itemsPerPage.value)
);

const pageText = computed(() =>
  `${(itemsPerPage.value * (page.value - 1)) + 1}–${Math.min(itemsPerPage.value * page.value, totalItems.value)} de ${totalItems.value}`
);

const itemsPerPageOptions = [5, 10, 25, 50, 100];

const goToFirstPage = () => {
  if (page.value > 1) page.value = 1;
};
const goToPreviousPage = () => {
  if (page.value > 1) page.value--;
};
const goToNextPage = () => {
  if (page.value < totalPages.value) page.value++;
};
const goToLastPage = () => {
  if (page.value < totalPages.value) page.value = totalPages.value;
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-4 py-0",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        align: "center",
        justify: "space-between",
        class: _normalizeClass(["mb-5", isMobile.value ? 'flex-column gap-2 pt-2' : 'mx-8 table-styles pt-2'])
      }, {
        default: _withCtx(() => [
          (isMobile.value)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                align: "center",
                justify: "center",
                class: "w-100",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "plain",
                    density: "compact",
                    disabled: _unref(page) === 1,
                    class: "px-2",
                    onClick: goToFirstPage
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode("mdi-page-first")
                        ])),
                        _: 1,
                        __: [2]
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    variant: "plain",
                    density: "compact",
                    disabled: _unref(page) === 1,
                    class: "px-2",
                    onClick: goToPreviousPage
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("mdi-chevron-left")
                        ])),
                        _: 1,
                        __: [3]
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createElementVNode("span", _hoisted_1, _toDisplayString(pageText.value), 1),
                  _createVNode(_component_v_btn, {
                    variant: "plain",
                    density: "compact",
                    disabled: _unref(page) === totalPages.value,
                    class: "px-2",
                    onClick: goToNextPage
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode("mdi-chevron-right")
                        ])),
                        _: 1,
                        __: [4]
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    variant: "plain",
                    density: "compact",
                    disabled: _unref(page) === totalPages.value,
                    class: "px-2",
                    onClick: goToLastPage
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("mdi-page-last")
                        ])),
                        _: 1,
                        __: [5]
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                align: "center",
                justify: "end",
                class: "w-100",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "mr-2" }, "Elementos por página:", -1)),
                  _createVNode(_component_v_select, {
                    modelValue: _unref(itemsPerPage),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(itemsPerPage) ? (itemsPerPage).value = $event : null)),
                    items: itemsPerPageOptions,
                    density: "compact",
                    style: {"max-width":"90px"},
                    class: "mr-8",
                    "hide-details": "",
                    variant: "outlined"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(pageText.value), 1),
                  _createVNode(_component_v_btn, {
                    variant: "plain",
                    density: "compact",
                    disabled: _unref(page) === 1,
                    class: "px-2",
                    onClick: goToFirstPage
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("mdi-page-first")
                        ])),
                        _: 1,
                        __: [6]
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    variant: "plain",
                    density: "compact",
                    disabled: _unref(page) === 1,
                    class: "px-2",
                    onClick: goToPreviousPage
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("mdi-chevron-left")
                        ])),
                        _: 1,
                        __: [7]
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    variant: "plain",
                    density: "compact",
                    disabled: _unref(page) === totalPages.value,
                    class: "px-2",
                    onClick: goToNextPage
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("mdi-chevron-right")
                        ])),
                        _: 1,
                        __: [8]
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    variant: "plain",
                    density: "compact",
                    disabled: _unref(page) === totalPages.value,
                    class: "px-2",
                    onClick: goToLastPage
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("mdi-page-last")
                        ])),
                        _: 1,
                        __: [9]
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1,
                __: [10]
              })),
          (isMobile.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_card_subtitle, null, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("Elementos por página")
                  ])),
                  _: 1,
                  __: [11]
                }),
                _createVNode(_component_v_row, {
                  class: "w-100 justify-center mt-2",
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _unref(itemsPerPage),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(itemsPerPage) ? (itemsPerPage).value = $event : null)),
                      items: itemsPerPageOptions,
                      density: "compact",
                      "hide-details": "",
                      variant: "outlined",
                      "max-width": "100px"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}
}

})